import React, { FC, SyntheticEvent, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

interface Props {
    key?: string | null;
    src?: string | null;
    description: string;
}

const DashboardImage: FC<Props> = ({
    key,
    src,
    description,
}) => {

    const [ failed, setFailed ] = useState(false);

    useEffect(() => {
        setFailed(false);
    }, [ src ]);

    const renderImageNotLinked = (key: string | null | undefined, description: string) => (
        <div key={key ? `${key}_div` : null}
             className="tooltipped text-red-500"
             data-toggle="tooltip"
             title={`No ${description} image linked.`}
        >
            <FontAwesomeIcon
                key={key ? `${key}_icon` : null}
                icon={faTimesCircle}
                className="block h-auto w-[40%] bg-transparent m-auto"
            />
        </div>
    );

    const setImageError = (e: SyntheticEvent<HTMLImageElement>) => {
        if (!failed) {
            e.currentTarget.src = "/images/unlink.svg";
            setFailed(true);
        }
    };

    return (
        <>
        {
            !src
                ? renderImageNotLinked(key, description)
                : <a key={key ? `${key}_a` : null} rel="noopener noreferrer" target="_blank" href={src}>
                    <img key={key}
                       src={src}
                       className="block w-auto max-w-full h-auto max-h-[200px] bg-[#000000] m-auto"
                       alt={description}
                       title={failed ? `Error loading ${src}` : description}
                       style={failed ? { width: "40%", backgroundColor: "transparent" } : {}}
                       onError={(e) => setImageError(e)}
                    />
                  </a>
        }
        </>
    );
};

export default DashboardImage;
